import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

export interface ComplianceResultListDialogData {
  compliant: string;
  results: {
    label: string;
    type: 'geometry' | 'list';
  }[];
  observation: string | null;
}

@Component({
  selector: 'compliance-result-list-dialog',
  templateUrl: 'compliance-result-list-dialog.component.html',
  styleUrls: ['compliance-result-list-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    CommonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplianceResultListDialog {
  readonly data = inject<ComplianceResultListDialogData>(MAT_DIALOG_DATA);
}
